import en from './en.json';
import it from './it.json';

export type Language = 'en' | 'it';

const translations = { en, it };

type NestedKeyOf<T> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? `${K}.${NestedKeyOf<T[K]>}` | K
          : K
        : never;
    }[keyof T]
  : never;

export type TranslationKey = NestedKeyOf<typeof en>;

export function getTranslation(lang: Language) {
  return translations[lang] || translations.en;
}

export function t(lang: Language, key: string): string {
  const translation = getTranslation(lang);
  const keys = key.split('.');
  let result: unknown = translation;

  for (const k of keys) {
    if (result && typeof result === 'object' && k in result) {
      result = (result as Record<string, unknown>)[k];
    } else {
      return key;
    }
  }

  return typeof result === 'string' ? result : key;
}

export { en, it };
